import { render, staticRenderFns } from "./AttachmentDate.vue?vue&type=template&id=6a54b7c5"
import script from "./AttachmentDate.vue?vue&type=script&lang=js"
export * from "./AttachmentDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports